import { saveAs } from 'file-saver';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import { DadosPessoaisAba1Response } from 'app/auth/_models/DadosPessoaisAba1';
import { ToastrService } from 'ngx-toastr';
import {
    DependentesServidorAba7Service
} from "../../service/dependentes-servidor-aba7/dependentes-servidor-aba7.service";
import {DependentesServidorDto} from "./dependentesServidor.dto";
import {TipoParentescoDto} from "../../model/tipoParentesco.dto";
import * as moment from "moment/moment";
import {DocumentosPessoaisDto} from "../recadastramento-aba3/documentosPessoais.dto";
import {MaskUtil} from "../../utils/mask-util";

@Component({
  selector: 'app-recadastramento-aba7',
  templateUrl: './recadastramento-aba7.component.html',
  styleUrls: ['./recadastramento-aba7.component.sass']
})
export class RecadastramentoAba7Component implements OnInit {

  @Input() dadosPessoaisUser: any;
  @Input() mostrarAlerta: any;
  @Output() voltarPagina: EventEmitter<void> = new EventEmitter<void>();
  @Output() dadosSalvos: EventEmitter<void> = new EventEmitter<void>();
  @Output() formularioSalvo = new EventEmitter<void>();
  @ViewChild('fileInputTipo') fileInputTipo!: ElementRef;
  @ViewChild('fileInputNome') fileInputNome!: ElementRef;
  @ViewChild('fileInputNascimento') fileInputNascimento!: ElementRef;

  formDependentes: FormGroup;
  formDependente: FormGroup;
  user: DadosPessoaisAba1Response = null;

  existDiffDataNascimento: boolean = false;

  flFileTipo: boolean;
  flFileNome: boolean;
  flFileNascimento: boolean;

  arquivoSelecionadoTipo: File;
  arquivoSelecionadoNome: File;
  arquivoSelecionadoNascimento: File;

  isLoadingFileTipo: boolean = false;
  isLoadingFileNome: boolean = false;
  isLoadingFileNascimento: boolean = false;

  existAnexoTipo: boolean = true;
  existAnexoNome: boolean = true;
  existAnexoNascimento: boolean = true;

  existDiffTipo: boolean = false;
  existDiffNome: boolean = false;
  existDiffNascimento: boolean = false;

  isLoading: boolean = true;
  isInfoImportantVisible: boolean = true;

  dependentes: DependentesServidorDto[];
  tipoParentescos: TipoParentescoDto[];

  constructor(
    private toasterService: ToastrService,
    private formBuilder: FormBuilder,
    private dependenteService: DependentesServidorAba7Service
  ) {
    this.user = JSON.parse(sessionStorage.getItem('SessionDataUserAuth'));


  }

  ngOnInit(): void {

      this.formDependentes = this.formBuilder.group({
          dependentes: this.formBuilder.array([])
      });
      this.carregarDadosInciais();
  }

  carregarDadosInciais(){
      this.dependenteService.getTipoParentescos().subscribe( resp => {
          this.tipoParentescos = resp
          this.getDependentes();
      })

  }

    private getDependentes() {
        this.dependenteService.getDependentes().subscribe(resp => {
            if (resp.length > 0) {
                this.dependentes = resp;
                for (let dep of resp) {
                    this.buildForm();
                    let dataNascimento = dep.dataNascimento !== null ? dep.dataNascimento.split('/') : '';
                    this.formDependente.patchValue(dep);

                    this.formDependente.get('flImpostoRenda')?.disable();
                    this.formDependente.get('flImpostoRenda')?.disable();

                    dep.flImpostoRenda === 'N' ? this.formDependente.get('flExclusaoImpostoRenda')?.disable() : false;

                    this.formDependente.get('existDiffTipo').patchValue(false);
                    this.formDependente.get('existDiffNascimento').patchValue(false);
                    this.formDependente.get('existDiffNome').patchValue(false);

                    /*!dep.isAnexoRg && dep.grauParentescoId ? this.formDependente.get('existDiffTipo').patchValue(true) : this.formDependente.get('existDiffTipo').patchValue(false);
                    !dep.isAnexoDataNascimento && (dep.cpf || dep.dataNascimento) ? this.formDependente.get('existDiffNascimento').patchValue(true) : this.formDependente.get('existDiffNascimento').patchValue(false);
                    !dep.isAnexoBlNome && dep.nomeDependente ? this.formDependente.get('existDiffNome').patchValue(true) : this.formDependente.get('existDiffNome').patchValue(false);
 */
                    dataNascimento !== '' ? this.formDependente.patchValue({dataNascimento: new Date(+dataNascimento[2], +dataNascimento[1] - 1, +dataNascimento[0])}) : false;
                    this.formList.push(this.formDependente);

                }
            }
        });
    }

    private buildForm() {
        this.formDependente = this.formBuilder.group({
            nomeDependente: ['', Validators.required],
            parentesco: [''],
            cpf: ['', [Validators.required, MaskUtil.validateCpfFormBuilder]],
            dataNascimento: ['', Validators.required],
            grauParentescoId: ['', Validators.required],
            idRecDependentes: [''],
            flExclusaoImpostoRenda: [],
            flDeficiente: [],
            flImpostoRenda: [],
            flExclusaoImpostoRendaCad: [],
            isAnexoDataNascimento: [''],
            isAnexoBlNome: [''],
            isAnexoRg: [''],
            numeDependente: [''],
            existDiffTipo: [],
            existDiffNascimento: [],
            existDiffNome: [],
        });
    }

    get formList() {
        return this.formDependentes.controls["dependentes"] as FormArray;
    }

  toggleInfoImportantVisible() {
    this.isInfoImportantVisible = !this.isInfoImportantVisible;
  }

  atualizarDependente() {
    //this.avancaParaProximoTab();
      let flValid: boolean[] = [];
      let d = this.formDependentes.getRawValue();
      d.dependentes.map( (dep, index) => {
          dep.dataNascimento = this.normalizeData(dep.dataNascimento);
          flValid.push(this.checkDiffForm(dep, index));
      });



      if(!flValid.includes(false)){
           if (this.formDependentes.valid) {
              this.dependenteService.salvarDependentes(d.dependentes).subscribe(
                  (response) => {
                     // this.getDocumentosPessoias();
                      this.toasterService.success('Dados atualizados com sucesso');
                      this.dadosSalvos.emit();
                  },
                  (error) => {
                      console.error('Erro ao atualizar os dados', error);
                      this.toasterService.error('Erro ao salvar Dados');
                  }
              );
           }
      } else {
          this.toasterService.error('Existem campos que precisam ser preenchidos.');
      }
  }

  checkDiffForm(dependente: DependentesServidorDto, index: number): boolean {
      let isTipo = true;
      let isNascimento = true;
      let isNome = true;

      if(this.getDependentesFormObject()['at'](index).get('existDiffTipo').value){
          isTipo = this.getDependentesFormObject()['at'](index).get('isAnexoRg').value;
      }

      if(this.getDependentesFormObject()['at'](index).get('existDiffNascimento').value){
          isNascimento = this.getDependentesFormObject()['at'](index).get('isAnexoDataNascimento').value
      }

      if(this.getDependentesFormObject()['at'](index).get('existDiffNome').value){
          isNome = this.getDependentesFormObject()['at'](index).get('isAnexoBlNome').value
      }

      /*let isTipo = this.checkDiffTipoParentesco(dependente, index)
      let isNascimento = this.checkDiffNascimento(dependente, index)
      let isNome = this.checkDiffNome(dependente, index)*/

      return !isTipo || !isNome || !isNascimento ? false : true;
  }

  getArquivos(idRecDependentes: string, tipo: string) {

    if(tipo === 'parentesco'){
        this.dependenteService.getArquivos(idRecDependentes, 'parentesco').subscribe((resp: Blob)=> {
            let blobRg: Blob;
            const fileType = resp.type || 'application/octet-stream';

            let fileName = 'Comprovante_Tipo';
            const fileExtension = this.getFileExtensionFromMimeType(fileType);

            if (fileExtension) {
                fileName += '.' + fileExtension;
            }

            blobRg = new Blob([resp], { type: fileType });
            this.downloadFile(blobRg, fileName);
            //blobRg !== null && undefined ? this.flFileRg = true : this.flFileRg = false;
        });
    }
    if(tipo === 'nome') {
        this.dependenteService.getArquivos(idRecDependentes,'nome').subscribe((resp: Blob) => {
            let blobCnh: Blob;
            const fileType = resp.type || 'application/octet-stream';

            let fileName = 'Comprovante_Nome';
            const fileExtension = this.getFileExtensionFromMimeType(fileType);

            if (fileExtension) {
                fileName += '.' + fileExtension;
            }
            blobCnh = new Blob([resp], { type: fileType });
            this.downloadFile(blobCnh, fileName);
            //this.blobCnh !== null && undefined ? this.flFileCnh = true : this.flFileCnh = false;
        });
    }

    if(tipo === 'data-nascimento') {
        this.dependenteService.getArquivos(idRecDependentes, 'data-nascimento').subscribe((resp: Blob) => {
            let blobTitulo: Blob;
            const fileType = resp.type || 'application/octet-stream';

            let fileName = 'Comprovante_Nascimento';
            const fileExtension = this.getFileExtensionFromMimeType(fileType);

            if (fileExtension) {
                fileName += '.' + fileExtension;
            }
            blobTitulo = new Blob([resp], { type: fileType });
            this.downloadFile(blobTitulo, fileName);
            //this.blobTitulo !== null && undefined ? this.flFileTitulo = true : this.flFileTitulo = false;
        });
    }
  }

  private getFileExtensionFromMimeType(mimeType: string): string | null {
      const extensionMap = {
          'application/pdf': 'pdf',
          'image/jpeg': 'jpeg',
          'image/jpg': 'jpg',
          'image/png': 'png'
          // Adicione outras extensões e tipos MIME conforme necessário
      };

      return extensionMap[mimeType] || null;
  }

  downloadFile(blob: Blob, fileName: string): void {
      saveAs(blob, fileName);
      this.toasterService.success('Arquivo baixado com sucesso');
  }

  getDependentesFormObject(){
      return this.formDependentes.get('dependentes')
  }

  enviarAnexoTipo(dependente: DependentesServidorDto, tipo: string, arquivo: File, index: number) {
      let listDependentes = this.getDependentesFormObject();
    if (arquivo) {
        this.toasterService.info('Enviando arquivo. Por favor, aguarde.');
        this.dependenteService.uploadComprovante(arquivo, dependente.numeDependente.toString(), tipo ).subscribe(
            (response) => {
                if(tipo == 'parentesco'){
                    this.isLoadingFileTipo = false;
                    listDependentes['at'](index).get('isAnexoRg').patchValue(true);
                    this.fileInputTipo.nativeElement.value = '';

                    //this.flFileTipo = true;
                    this.toasterService.success('Arquivo enviado');
                }
                if(tipo == 'nome'){
                    this.isLoadingFileNome = false;
                    listDependentes['at'](index).get('isAnexoBlNome').patchValue(true);
                    //this.flFileNome = true;
                    this.fileInputNome.nativeElement.value = '';
                    this.toasterService.success('Arquivo enviado');
                }
                if(tipo == 'data-nascimento'){
                    this.isLoadingFileNascimento = false;
                    listDependentes['at'](index).get('isAnexoDataNascimento').patchValue(true);
                    //this.flFileNascimento = true;
                    this.fileInputNascimento.nativeElement.value = '';
                    this.toasterService.success('Arquivo enviado');
                }

            },
            (error) => {
                if(tipo == 'parentesco')this.fileInputTipo.nativeElement.value = '';
                if(tipo == 'nome') this.fileInputNome.nativeElement.value = '';
                if(tipo == 'data-nascimento') this.fileInputNascimento.nativeElement.value = '';
                if(error.status == 422){
                    this.toasterService.warning('O arquivo anexado excede o tamanho máximo permitido de 10 MB.');
                }else{
                    this.toasterService.error(`Erro ao enviar o anexo: ${error.error.message}`);
                }
                this.onArquivoExcluidoTipo(dependente, index)
            }
        );
    }
  }

  onArquivoExcluidoTipo(dependente: DependentesServidorDto,index: number) {
    this.getDependentesFormObject()['at'](index).get('isAnexoRg').patchValue(false);
    this.checkDiffTipoParentesco(dependente, index, true);
    this.getDependentesFormObject()['at'](index).get('existDiffTipo').patchValue(true);
    this.flFileTipo = false;
    this.arquivoSelecionadoTipo = null;
    /*const input = document.getElementById('input-file-Tipo') as HTMLInputElement;
    input.value = '';*/
  }

    onArquivoExcluidoNome(dependente: DependentesServidorDto, index: number) {
        this.getDependentesFormObject()['at'](index).get('isAnexoBlNome').patchValue(false);
        this.checkDiffNome(dependente, index, true);
        this.getDependentesFormObject()['at'](index).get('existDiffNome').patchValue(true);
        this.flFileNome = false;
        this.arquivoSelecionadoNome = null;
        /*const input = document.getElementById('input-file-Nome') as HTMLInputElement;
        input.value = '';*/
    }

    onArquivoExcluidoNascimento(dependente: DependentesServidorDto,index: number) {
        this.getDependentesFormObject()['at'](index).get('isAnexoDataNascimento').patchValue(false);
        this.checkDiffNascimento(dependente, index, true);
        this.getDependentesFormObject()['at'](index).get('existDiffNascimento').patchValue(true);
        this.flFileNascimento = false;
        this.arquivoSelecionadoNascimento = null;
       /* const input = document.getElementById('input-file-Nascimento') as HTMLInputElement;
        input.value = '';*/
    }

  onArquivoSelecionado(event: any, tipoDocumento: string, dependente: DependentesServidorDto, index: number) {
    const allowedFileTypes = ['image/jpeg', 'image/png', 'application/pdf'];
    const maxFileSizeInBytes = 1024 * 1024 * 10; // 10 MB
    const file = event.target.files[0];

    if (file && allowedFileTypes.includes(file.type) && file.size <= maxFileSizeInBytes) {
        switch (tipoDocumento){
            case 'parentesco':
                this.isLoadingFileTipo = true;
                this.arquivoSelecionadoTipo = file;
                this.existAnexoTipo = true;
                this.enviarAnexoTipo(dependente, tipoDocumento, this.arquivoSelecionadoTipo, index);
                break;
            case 'nome':
                this.isLoadingFileNome = true;
                this.arquivoSelecionadoNome= file;
                this.existAnexoNome = true;
                this.enviarAnexoTipo(dependente, tipoDocumento,  this.arquivoSelecionadoNome, index);
                break
            case 'data-nascimento':
                this.isLoadingFileNascimento = true;
                this.arquivoSelecionadoNascimento = file;
                this.existAnexoNascimento = true;
                this.enviarAnexoTipo(dependente, tipoDocumento, this.arquivoSelecionadoNascimento, index);
                break
        }

    }
    else {
        this.arquivoSelecionadoTipo = null;

        if (!allowedFileTypes.includes(file.type)) {
            this.toasterService.warning('Tipo de arquivo inválido! Apenas arquivos JPG, JPEG, PNG e PDF são permitidos.');
        } else if (file.size > maxFileSizeInBytes) {
            this.toasterService.warning('O arquivo anexado excede o tamanho máximo permitido de 10 MB.');
        }
        switch (tipoDocumento){
            case 'parentesco':
                this.onArquivoExcluidoTipo(dependente, index)
                this.getDependentesFormObject()['at'](index).get('existDiffTipo').patchValue(true);
                break;
            case 'nome':
                this.onArquivoExcluidoNome(dependente, index)
                this.getDependentesFormObject()['at'](index).get('existDiffNascimento').patchValue(true);
                break;
            case 'data-nascimento':
                this.onArquivoExcluidoNascimento(dependente, index)
                this.getDependentesFormObject()['at'](index).get('existDiffNome').patchValue(true);
                break;
        }



    }
  }

  checkDiffTipoParentesco(dependente: DependentesServidorDto, index: number, eventExclusao: boolean = false) {
    if(dependente.grauParentescoId != this.dependentes[index].grauParentescoId ){

        this.getDependentesFormObject()['at'](index).get('existDiffTipo').patchValue(true)
        if(this.getDependentesFormObject()['at'](index).get('isAnexoRg').value){
            this.getDependentesFormObject()['at'](index).get('isAnexoRg').patchValue(false)
        }
        if(!this.getDependentesFormObject()['at'](index).get('isAnexoRg').value){
            //this.existAnexoTipo = false;
            return true;
        }else {
            return false
        }
    } else {
        if(this.dependentes[index].isAnexoRg && !eventExclusao){
            this.getDependentesFormObject()['at'](index).get('isAnexoRg').patchValue(true);
        }
        this.getDependentesFormObject()['at'](index).get('existDiffTipo').patchValue(false)
        this.existAnexoTipo = true;
        return false
    }
  }

  checkDiffNascimento(dependente: DependentesServidorDto, index: number, eventExclusao: boolean = false) {
    let dataNascimento: string;

    dataNascimento = this.normalizeData(dependente.dataNascimento);

    if( this.dependentes[index].cpf !== dependente.cpf ||
        this.dependentes[index].dataNascimento !== dataNascimento
    ){

        this.getDependentesFormObject()['at'](index).get('existDiffNascimento').patchValue(true);

        if(this.getDependentesFormObject()['at'](index).get('isAnexoDataNascimento').value){
            this.getDependentesFormObject()['at'](index).get('isAnexoDataNascimento').patchValue(false);
        }

        if(!this.getDependentesFormObject()['at'](index).get('isAnexoDataNascimento').value){
            this.existAnexoNascimento = false;
            return true;
        } else {
            return false
        }
    } else {
        if(this.dependentes[index].isAnexoDataNascimento && !eventExclusao){
            this.getDependentesFormObject()['at'](index).get('isAnexoDataNascimento').patchValue(true);
        }
        this.getDependentesFormObject()['at'](index).get('existDiffNascimento').patchValue(false);
        this.existAnexoNascimento = true;
        return false
    }



      if(dependente.nomeDependente != this.dependentes[index].nomeDependente.trim() ||
          this.dependentes[index].isAnexoBlNome != this.getDependentesFormObject()['at'](index).get('isAnexoBlNome').value){

          this.getDependentesFormObject()['at'](index).get('existDiffNome').patchValue(true)
          if(this.getDependentesFormObject()['at'](index).get('isAnexoBlNome').value){
              this.getDependentesFormObject()['at'](index).get('isAnexoBlNome').patchValue(false);
          }
          if(!this.getDependentesFormObject()['at'](index).get('isAnexoBlNome').value){
              this.existAnexoNome = false;
              return true
          } else {
              return false
          }
      } else {
          if(this.dependentes[index].isAnexoBlNome){
              this.getDependentesFormObject()['at'](index).get('isAnexoBlNome').patchValue(true);
          }
          this.getDependentesFormObject()['at'](index).get('existDiffNome').patchValue(false);
          this.existAnexoNome = true;
          return false;
      }
  }

    private normalizeData(dependente: string) {
        return moment(dependente).format('DD/MM/YYYY');
    }

    checkDiffNome(dependente: DependentesServidorDto, index: number, eventExclusao: boolean = false) {
      if(dependente.nomeDependente != this.dependentes[index].nomeDependente.trim()){
          this.getDependentesFormObject()['at'](index).get('existDiffNome').patchValue(true)
          if(this.getDependentesFormObject()['at'](index).get('isAnexoBlNome').value){
              this.getDependentesFormObject()['at'](index).get('isAnexoBlNome').patchValue(false);
          }
          if(!this.getDependentesFormObject()['at'](index).get('isAnexoBlNome').value){
              this.existAnexoNome = false;
              return true
          } else {
              return false
          }
      } else {
          if(this.dependentes[index].isAnexoBlNome && !eventExclusao){
              this.getDependentesFormObject()['at'](index).get('isAnexoBlNome').patchValue(true);
          }
          this.getDependentesFormObject()['at'](index).get('existDiffNome').patchValue(false);
          this.existAnexoNome = true;
          return false;
      }
  }


  avancaParaProximoTab() {
    this.dadosSalvos.emit()

  }
  voltarPaginaAnterior() {
    this.voltarPagina.emit()
  }
}
